import { Controller } from "@hotwired/stimulus"

// Opens the calendar on today. On a phone the days stack, so today's panel
// scrolls to the top; on a wide screen the week fits, so it only scrolls if
// today is off screen. Skipped when a call card is reopening after an edit.
export default class extends Controller {
  static targets = ["today"]
  static values = { enabled: Boolean }

  connect() {
    if (!this.enabledValue || !this.hasTodayTarget) return

    const phone = window.matchMedia("(max-width: 767px)").matches
    requestAnimationFrame(() => {
      this.todayTarget.scrollIntoView({ block: phone ? "start" : "nearest", behavior: "auto" })
    })
  }
}
